'use strict';

import Analytics from 'helpers/analytics/analytics';

function submission(event) {
  let errorAlreadyFound = false;
  return {
    doNothing: function() {},
    doStop: function(validatableInputField) {
      event.preventDefault();
      validatableInputField.focus();
      errorAlreadyFound = true;
    },
    stop: function(validatableInputField) {
      (errorAlreadyFound ? this.doNothing : this.doStop)(validatableInputField);
    }
  };
}

function create(element, fields, successCallback, failureCallback) {
  if (!element) {
    throw new Error('form element was not defined');
  }

  if (!fields) {
    throw new Error('form fields were not defined');
  }

  function formSubmission(e) {
    Analytics.resetErrors();
    let submissionVisitor = submission(e);

    let success = true;
    let failingElements = [];
    [].forEach.call(fields, function(field) {
      if (!field.validateSubmission(submissionVisitor)) {
        success = false;
        if (field.getFocusElement) {
          failingElements.push({
            focusTarget: field.getFocusElement(),
            validationElement: field.getValidationElement()
          })
        }
      }
    });

    if (success && successCallback) {
      successCallback(e);
    } else if (!success && failureCallback) {
      failureCallback(e, failingElements);
    }

    Analytics.publish();
  }

  element.addEventListener('submit', formSubmission);

}

export let form = {
  create
};
